import { contactInfo } from "@/mocks/home";

const stats = [
  { value: "38,200+", label: "누적 수리 건수" },
  { value: "0.7%", label: "재수리율" },
  { value: "30분", label: "평균 정밀 진단" },
  { value: "6개월", label: "최대 무상 보증" },
];

const HERO_VIDEO_SRC = "";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      {/* Background: looping video of mainboard inspection (falls back to motion image) */}
      <div className="absolute inset-0">
        {HERO_VIDEO_SRC ? (
          <video
            className="h-full w-full object-cover object-top"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="https://readdy.ai/api/search-image?query=Extreme%20close-up%20macro%20of%20a%20disassembled%20laptop%20motherboard%20being%20inspected%20with%20precision%20tweezers%20under%20bright%20task%20light%2C%20dark%20moody%20repair%20lab%20background%20with%20subtle%20cool%20blue%20technical%20lighting%2C%20visible%20copper%20circuit%20traces%20and%20micro%20chips%2C%20cinematic%20high%20detail%20photography&width=1920&height=1080&seq=hero-mainboard-mfx&orientation=landscape&nocache=true"
            aria-label="맥북을 분해하고 메인보드를 정밀 검사하는 수리 과정 영상"
          >
            <source src={HERO_VIDEO_SRC} type="video/mp4" />
          </video>
        ) : (
          <img
            src="https://readdy.ai/api/search-image?query=Extreme%20close-up%20macro%20of%20a%20disassembled%20laptop%20motherboard%20being%20inspected%20with%20precision%20tweezers%20under%20bright%20task%20light%2C%20dark%20moody%20repair%20lab%20background%20with%20subtle%20cool%20blue%20technical%20lighting%2C%20visible%20copper%20circuit%20traces%20and%20micro%20chips%2C%20cinematic%20high%20detail%20photography&width=1920&height=1080&seq=hero-mainboard-mfx&orientation=landscape"
            alt="맥북 메인보드를 정밀 검사하는 수리 현장"
            title="맥픽스 맥북 메인보드 정밀 검사"
            className="h-full w-full object-cover object-top animate-slow-zoom"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/88 via-foreground-950/72 to-foreground-950/92"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/70 to-transparent"></div>
      </div>

      {/* subtle scan grid */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(oklch(var(--accent-300)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--accent-300)) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      ></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-28 md:px-8 md:py-32">
        <div className="flex flex-col items-center">
          <div
            className="animate-float-up mx-auto flex max-w-3xl flex-col items-center text-center opacity-0"
            style={{ animationDelay: "0.1s" }}
          >
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-4 py-1.5 font-label text-sm font-bold text-accent-200 backdrop-blur-sm">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-accent-400"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
              </span>
              맥북 · 아이맥 회로 수리 전문
            </span>

            <h1 className="mt-6 font-heading text-4xl font-black leading-[1.12] tracking-tight text-background-50 md:text-6xl">
              맥북의 심장
              <br />
              <span className="text-gradient-anim">회로부터 다시</span> 살립니다
            </h1>

            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-background-200 md:text-lg">
              단순 부품 교체를 넘어 메인보드·회로 단위까지 진단합니다. 15년 경력 엔지니어가
              회로도 기반으로 원인을 찾아내고, 수리 전 과정을 투명하게 공유합니다.
            </p>

            <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
              <a
                href="#inquiry"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-4 font-label text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-search-eye-line text-lg"></i>
                무료 정밀 진단 신청
              </a>
              <a
                href={contactInfo.phoneHref}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/5 px-7 py-4 font-label text-base font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/15"
              >
                <i className="ri-phone-line text-lg"></i>
                {contactInfo.phone}
              </a>
            </div>
          </div>

        </div>

        <div className="mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur-sm md:grid-cols-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-foreground-950/40 px-5 py-6 text-center transition-colors hover:bg-foreground-950/60"
            >
              <div className="mx-auto mb-3 h-1 w-8 rounded-full bg-accent-400"></div>
              <div className="font-heading text-3xl font-black tracking-tight text-background-50 md:text-4xl">
                {stat.value}
              </div>
              <div className="mt-1.5 font-label text-xs font-medium text-background-300 md:text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}